import React from 'react'
import Modal from 'react-modal'
import moment from 'moment'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { lease } from '../../core/controllers/Lease'
import { modalStyles } from '../../core/controllers/ModalStyles';
import { modal } from '../../core/utilities/modal';
import { user } from '../../core/controllers/user';

export default class SalesReportedList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reports: null,
            selectedReport: null,
            showModal: false,
            amount: 0,
            leaseId: props.leaseId
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        if (user.userInfo.user_type_alias != 'tenant') {
            lease.getSalesReportedWithLease(this.props.leaseId, function(response) {
                self.setState({
                    reports: response.data
                });
            });
        } else {
            lease.getSalesReported(function(response) {
                self.setState({
                    reports: response.data
                });
            });
        }
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseInt(value);
        money = Number(money.toFixed(2)).toLocaleString();
        if(money == 'NaN') { money = 0; }

        return money;
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    formatStatus(cell, row) {
        var status = '<span class="important-small-orange">Pending</span>';
        if (row.tenant_payment_history_id != 0) {
            status = '<span class="important-small-green">Reported</span>';
        }
        return status;
    }

    formatAmountAndClick(cell, row) {
        if (row.tenant_payment_history_id == 0) {
            return (
                <span onClick={this.reportAmount.bind(this, row)}>
                    ${this.formatAmount(row.amount)} &nbsp;
                    <i class="pe-7s-pen download-invoice"></i>
                </span>
            )
        } else {
            return '$' + this.formatAmount(cell);
        }
    }

    formatDate(cell, row) {
        if(cell) {
            return moment(cell).format('D MMM YYYY');
        } else {
            return 'Not Set';
        }
    }

    reportAmount(report) {
        this.setState({showModal: true, selectedReport: report, amount: report.amount});
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    handleNewAmount(e) {
        this.setState({
            amount: e.target.value
        });
    }

    validateData() {
        const amount = this.state.amount.toString().replace(',', '').replace('.', '');

        if (amount == null || amount <= 0) {
            modal.showInfo("Enter the amount you want to report this month.", "warning", "top", "center");
            return false;
        } else if(isNaN(amount)) {
            modal.showInfo("Enter a valid amount.  Make sure you have no text or symbols like $.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    reportSales(report) {
        if(!this.validateData()){
            return;
        }
        var self        = this;
        const newAmount = this.state.amount;
        modal.showDangerModalWithOK("Report Sales", "Are you sure you want to report this amount?", "Yes");
        jQuery(".move-on").on('click',function() {
            lease.reportSales(report, newAmount, function() {
                modal.showInfo("Sales were successfully reported.", "success", "top", "center");
                lease.getSalesReported(function(response) {
                    self.setState({
                        reports: response.data,
                        showModal: false,
                        selectedReport: null
                    });
                });
            });
        });
    }

    render(){
        var reports          = this.state.reports;
        const showModal      = this.state.showModal;
        const amount         = this.state.amount;
        const selectedReport = this.state.selectedReport;
        if (reports != null && typeof reports !== undefined) {
            reports = reports.map(function(report) {
                return {
                    name: moment(report.for_month).format('MMMM Y'),
                    amount: report.amount / 100,
                    created_at: report.created_at,
                    tenant_payment_history_id: report.tenant_payment_history_id,
                    tenant_sales_report_id: report.tenant_sales_report_id
                }
            });
        }

        return (
            <div class="row">
                <div class="col-md-12">
                    <div class="content">
                    <Modal
                        isOpen={showModal}
                        onRequestClose={this.handleCloseModal.bind(this)}
                        style={modalStyles.getModalStyles()}
                        ariaHideApp={false}>
                        <div>
                            <div class="row">
                                <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this)}></div>
                            </div>
                            <div class="row">
                                <div class="modal-header">Report Sales</div>
                            </div>
                            <form>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6 col-md-offset-3">
                                                <div class="form-group">
                                                    <label for="assignee">How much was sales last month?</label>
                                                    <input type="text" class="form-control" onChange={this.handleNewAmount.bind(this)} value={amount} placeholder="Enter an amount" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                        <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.reportSales.bind(this, selectedReport)}>
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Modal>
                    {reports != null ? (
                        window.innerWidth < 992 ? (
                        <BootstrapTable data={reports} version='4' striped search pagination hover>
                            <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='name'>Month</TableHeaderColumn>
                            <TableHeaderColumn dataField='amount' dataFormat={this.formatAmountAndClick.bind(this)}>Sales</TableHeaderColumn>
                            <TableHeaderColumn dataField='status' dataFormat={this.formatStatus}>Status</TableHeaderColumn>
                        </BootstrapTable>
                        ) : (
                        <BootstrapTable data={reports} version='4' striped search pagination hover>
                            <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='name'>Month</TableHeaderColumn>
                            <TableHeaderColumn dataField='amount' dataFormat={this.formatAmountAndClick.bind(this)}>Sales</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.formatDate}>Created</TableHeaderColumn>
                            <TableHeaderColumn dataField='status' width="150" dataFormat={this.formatStatus}>Status</TableHeaderColumn>
                        </BootstrapTable>
                        )
                    ) : (
                        <p class="col-md-12">No sales reported yet.</p>
                    )}
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Leases/SalesReportedList.jsx